

































































import Vue from 'vue'
import { api } from '@/singleton'
import mixins from 'vue-typed-mixins'
import { presetDialogMixin } from '@/mixins'
import easyapi from '@/easyapi'
import { deepCopy, generateUnoccupiedId, checkNameDuplicated, getMatrixMap } from '@/utils'
import { isEqual } from 'lodash'
import { ApiVw, Matrix, Extender, Preset } from '@/types/api'
import VwPreviewScreen from '@/components/VwPreviewScreen.vue'
import PreviewScreen from '@/components/PreviewScreen.vue'
import CheckboxIcon from '@/components/CheckboxIcon.vue'
import { MatrixMap, getDevRef } from '@/store/modules/device'
import { IDevice } from '@/types/model'
import VueI18n from 'vue-i18n'


export default mixins(presetDialogMixin).extend({
  components: {
    PreviewScreen,
    VwPreviewScreen,
  },
  data (): {
    getDevRef: typeof getDevRef,
    nameFilterStr: string,
  } {
    return {
      getDevRef,
      nameFilterStr: '',
    }
  },
  computed: {
    preset (): Preset | null { return this.dialog.preset },
    matrixList (): Matrix[] { return this.preset ? this.preset.matrixList : [] },
    vwList (): ApiVw[] { return this.preset ? this.preset.vwList : [] },
    isDesktop (): boolean { return this.$state.common.windowSize.width > 600 },
    alertData (): {type: string, text: VueI18n.TranslateResult} {
      if (this.nameDuplicated) {
        return { type: 'warning', text: this.$t('msg.nameCannotDuplicated') }
      }
      return {
        type: 'info',
        text: ''
      }
    },
    nameDuplicated (): boolean {
      if (!this.preset) { return false }
      return checkNameDuplicated(this.preset.name, null, this.$state.device.presetList)
    }
  },
  methods: {
    getDevName (mac: string): string {
      const dev = getDevRef(mac)
      if (dev) { return this.dn(dev) }
      return ''
    },
    apply () {
      if (!this.preset) {return}
      easyapi.applyPreset(this.preset).then(ok => {
        if (ok) {
          this.closeThisDialog()
        }
      })
    },
  },
  watch: {
  }
})
